(ns common.schema.entities.message-options
  (:require
   [common.util :as cu]))

(def options
  [{:key   :message.type/linkedin
    :label "LinkedIn"}
   {:key   :message.type/skype
    :label "Skype"}
   {:key   :message.type/whatsapp
    :label "WhatsApp"}
   {:key   :message.type/facebook
    :label "Facebook"}
   {:key   :message.type/telegram
    :label "Telegram"}
   {:key   :message.type/email
    :label "Email"}
   {:key   :message.type/slack
    :label "Slack"}
   {:key   :message.type/signal
    :label "Signal"}
   {:key   :message.type/ms-teams
    :label "MS Teams"}
   {:key   :message.type/other
    :label "Other"}])

(defn get-label
  [k]
  (->> options
       (cu/filter-by :key k)
       (first)
       :label))
